// extracted by mini-css-extract-plugin
export default {"SavedViewsList":"Sidebar-module__SavedViewsList--gjKCu","SidebarContainer":"Sidebar-module__SidebarContainer--kYEwB","sidebarFooter":"Sidebar-module__sidebarFooter--yPHGM"};